import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { XIcon } from 'lucide-react';
import { DefaultPopover, Row, Col, FormGroup, Label, Input, Separator, Button } from 'twyne-new.ui';

import Select from 'components/form/Select';

const propTypes = {
  options: PropTypes.array,
  isVisible: PropTypes.bool,
  target: PropTypes.string,
  onClose: PropTypes.func,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func,
  onEdit: PropTypes.func,
  values: PropTypes.object,
  getLabel: PropTypes.func,
};

function PathItem({ options, weigth, pathId, onChange }) {
  return (
    <Row>
      <Col size="12">
        <FormGroup>
          <Label>Path</Label>
          <Select
            clearable={false}
            name="path_id"
            options={options}
            handleOnChange={opt => onChange('pathId', opt.value)}
            value={pathId}
            required
          />
        </FormGroup>
      </Col>
      <Col size="12">
        <FormGroup>
          <Label>Weight</Label>
          <Input
            type="number"
            value={weigth}
            onChange={e => onChange('weigth', e.target.value)}
            min={1}
          />
        </FormGroup>
      </Col>
    </Row>
  )
}

export default function ManagePath({ options, isVisible, onClose, onAdd, onRemove, onEdit, values, getLabel, target }) {
  const [weigth, setWeigth] = useState()
  const [pathId, setPathId] = useState()

  useEffect(() => {
    const { weigth, path_id: pathId } = values || {}
    setWeigth(weigth || 1)
    setPathId(pathId)
  }, [isVisible, values])

  const handleOnChange = (key, value) => {
    const setState = {
      weigth: setWeigth,
      pathId: setPathId,
    }
    setState[key](value)
  }

  const handleApply = () => {
    values ? onEdit({ pathId, weigth }) : onAdd({ pathId, weigth })
    onClose()
  }

  const disabled = !weigth || !pathId

  return target && <DefaultPopover
    wrapperProps={{ open: isVisible, onOpenChange: onClose }}
    target={`#${target}`}
    triggerProps={{ asChild: true }}
  >
    <div className='flex justify-between items-start gap-2'>
      <div className='min-w-0'>
        {values ? <>
          Edit <Link to={`/path/paths/${values.path_id}`} target='_blank' className='twy-text-accent hover:underline whitespace-normal break-all'>
            [#{values.path_id}] {getLabel(values.path_id)}
          </Link>
        </> : 'Add Path'}
      </div>
      <XIcon size='16' className='cursor-pointer' onClick={onClose} />
    </div>
    <Separator className='m-0 my-2' />

    <PathItem weigth={weigth} pathId={pathId} options={options} onChange={handleOnChange} />

    <div className='flex gap-2 mt-2'>
      <Button
        block
        size="sm"
        color="accent"
        onClick={handleApply}
        disabled={disabled}
      >
        Apply
      </Button>
      {values && <Button
        variant='ghost'
        block
        size="sm"
        color="danger"
        onClick={onRemove}
      >
        Remove
      </Button>}
    </div>
  </DefaultPopover>
}

ManagePath.propTypes = propTypes
ManagePath.defaultProps = {}
